import React, { useRef } from "react";
import { View, Text, TextInput, StyleSheet, Platform, SafeAreaView } from "react-native";

type Props = {
  title: string;
  subTitle: string;
  pinError: string;
  pin: string[];
  handleChange: (text: string, index: number) => void;
};

const PinInputComponent: React.FC<Props> = ({
  title,
  subTitle,
  pinError,
  pin,
  handleChange,
}) => {
  const Wrapper = Platform.OS === "web" ? View : SafeAreaView;
  const inputs = useRef<(TextInput | null)[]>([]);
  return (
    <Wrapper style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.subtitle}>{subTitle}</Text>

      <View style={styles.pinContainer}>
        {pin.map((digit, index) => (
          <TextInput
            key={index}
            ref={(el) => (inputs.current[index] = el)}
            style={styles.pinInput}
            keyboardType="number-pad"
            maxLength={1}
            secureTextEntry
            value={digit}
            onChangeText={(text) => handleChange(text, index)}
          />
        ))}
      </View>

      {pin.join("").length > 0 && pin.join("").length < 4 && (
        <Text style={styles.error}>{pinError}</Text>
      )}
    </Wrapper>
  );
}

export default PinInputComponent;

const styles = StyleSheet.create({
  container: {
    justifyContent: "flex-start",
  },
  title: {
    fontSize: 22,
    fontWeight: "700",
    marginBottom: 6,
    color: "#111827",
  },
  subtitle: {
    fontSize: 14,
    color: "#6B7280",
    marginBottom: 20,
  },
  pinContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  pinInput: {
    width: 60,
    height: 60,
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 12,
    textAlign: "center",
    fontSize: 22,
    fontWeight: "600",
    backgroundColor: "#F9FAFB",
    marginRight: 24
  },
  error: {
    color: "red",
    fontSize: 12,
    marginTop: 8,
  },
});
